import React from 'react';
export const injectPropsIntoInput = (node, inputProps) => {
    if (Array.isArray(node)) {
        return node.map((child) => injectPropsIntoInput(child, inputProps));
    }
    if (React.isValidElement(node)) {
        if (node.type === 'input') {
            return React.cloneElement(node, { ...inputProps, ...node.props });
        }
        if (node.props && node.props.children) {
            return React.cloneElement(node, {
                children: React.Children.map(node.props.children, child => injectPropsIntoInput(child, inputProps)),
            });
        }
        return node;
    }
    if (React.isValidElement(node) &&
        node.type === React.Fragment &&
        node.props?.children) {
        return React.cloneElement(node, {}, React.Children.map(node.props.children, child => injectPropsIntoInput(child, inputProps)));
    }
    return node;
};
//# sourceMappingURL=injectPropsIntoInput.js.map